import { action, extendObservable } from 'mobx';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import { Roles } from '../../../core/util';
import averageLevelChartService from './AverageLevelChartService';
import errorsPerAbilityChartService from './ErrorsPerAbilityChartService';
import errorsPerGrammarChartService from './ErrorsPerGrammarChartService';
import placementTestsPerLevelChartService from './PlacementTestsPerLevelChartService';
import placementTestReportStudentsListService from './PlacementTestReportStudentsListService';
import placementTestGlobalTotalService from './PlacementTestGlobalTotalService';

class PlacementTestReportFilterService {
  form = new FormService();
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {});
    this.form.setInitialValues({
      companies: [],
      schools: [],
      schoolClasses: [],
      periodStart: null,
      periodEnd: null,
      keyword: null,
      placementTestLevel: [],
      status: null,
    });
  }

  init = action(() => {
    if (localStorage.getItem('role') === Roles.COMPANY_MANAGER) {
      this.form.setValue('companies', [localStorage.getItem('company')]);
    }
    if ([Roles.SCHOOL_MANAGER, Roles.TEACHER].some((role) => role === localStorage.getItem('role'))) {
      this.form.setValue('schools', [localStorage.getItem('school')]);
    }
  });

  handleSearch = action(() => {
    averageLevelChartService.load();
    placementTestsPerLevelChartService.load();
    errorsPerAbilityChartService.load();
    errorsPerGrammarChartService.load();
    placementTestReportStudentsListService.load();
    placementTestGlobalTotalService.load();
  });

  handleSearchStudents = action(() => {
    placementTestReportStudentsListService.load();
  });
}

const placementTestReportFilterService = new PlacementTestReportFilterService();
export default placementTestReportFilterService;
